import { Box, Button, Paper } from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import ContentRight from "shared/molecules/content-right";
import { makeStyles } from "@mui/styles";
import { indigo } from "@mui/material/colors";
import { TypographyHeading } from "shared/molecules/typography-layout";
import Loader from "pages/build-test/loader";
import { useEffect, useState } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_BATCH_LIST } from "utils/graphql/services/entities/queries";
import entitesClient from "utils/graphql/entitiesClient";
import { DELETE_BATCH } from "utils/graphql/services/entities/mutations";
import { GET_COLLEGE_IPS } from "utils/graphql/services/operations/queries";
import SectionTable from "shared/organisms/tables/table";
import { table, tableRead } from "./helper";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import {
  academicTagsUser,
  checkFeatureAccess,
} from "utils/role-restriction/helper";
import { QuestionIpFilter } from "./filter";
import NoDataFound from "shared/molecules/no-data";
import { DELETE_COLLEGE_IP } from "utils/graphql/services/operations/mutations";
import CollapsibleTable from "shared/organisms/tables/collapsible-table";

const useStyles: any = makeStyles((indigoTheme) => ({
  label: {
    textDecoration: "none",
    textAlign: "center",
    color: indigo[700],
    marginLeft: "80%",
  },
  Btn: {
    backgroundColor: "#3f50b5",
    color: "white",
    width: "90px",
  },
  BtnWrapper: {
    display: "flex",
    gap: "20px",
    justifyContent: "flex-end",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
}));
export const QuestionIp = () => {
  const classes = useStyles();
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [searchPayload, setSearchPayload] = useState({});
  const [clearValuesTrigger, setClearValuesTrigger] = useState(false);

  const { profileData } = useAppSelector((state) => state.gmailLoginReducer);
  const { role: userRoleStr } = profileData;
  const userRole = userRoleStr?.split(",");

  const [getCollegeIPs, { loading, error, data }] = useLazyQuery(
    GET_COLLEGE_IPS,
    {
      client: entitesClient,
    }
  );

  const [deleteCollegeIp, { loading: loadingD, error: errorD, data: dataD }] =
    useMutation(DELETE_COLLEGE_IP, {
      client: entitesClient, // Ensure you're using the correct GraphQL client instance
    });

  const handleEdit = (obj) => {
    history.push(`/operations/question_ip/update?id=${obj?.id}`);
  };

  const handleDelete = async (id) => {
    try {
      const response: any = await deleteCollegeIp({
        variables: { id },
      });

      if (response?.data?.deleteCollegeIpAddress?.success) {
        dispatch(snackbarRequest({ message:`${response?.data?.deleteCollegeIpAddress?.message}`|| "deleted successfully" }));
         setClearValuesTrigger(!clearValuesTrigger);
      } else {
        dispatch(
          snackbarRequest({
            message: `${response?.errorReason}`,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(snackbarRequest({ message: `${err}`, type: "error" }));
    }
  };

  useEffect(() => {
     getCollegeIPs({ variables: { filter: { ...searchPayload, limit, offset } } });
  }, [searchPayload, offset]);


  const hasModificationAccess = checkFeatureAccess(
    userRole,
    academicTagsUser.ACADEMIC_TAGS_READ_WRITE
  );

  return (
    <>
      <ContentRight>
        <Link to="question_ip/create" className={classes.label}>
          <Button variant="contained">Create Config </Button>
        </Link>
      </ContentRight>
      <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
       Branch IP Config
      </TypographyHeading>
      <QuestionIpFilter
        setSearchPayload={setSearchPayload}
        setOffset={setOffset}
        clearValuesTrigger={clearValuesTrigger}
      />
      <Paper elevation={2} sx={{ px: 2, pb: 4, paddingTop: 2, mt: 2 }}>
        <div>{loading && <Loader />}</div>
        <div>
          {!loading && data?.getCollegeIpAddresses?.length > 0 && (
            <CollapsibleTable
              data={data?.getCollegeIpAddresses}
              table={ table }
              id="id"
              name="id"
              handleEdit={handleEdit}
              handleDelete={handleDelete}
              rowsPerPageCount={10}
              // rowsPerPageCount={0}
              // style="false"
              // totlaRecords={data?.getCollegeIpAddresses?.length || 0}
             paginationSegmentApi="false"
            hasPageApiCall={false}
            showPaginationFooter={false}
            />
          )}
        </div>
        <div>{!loading && data?.getCollegeIpAddresses?.length === 0 && <NoDataFound message="No Data" />}</div>
        <Box className={classes.BtnWrapper}>
          <Button
            onClick={() => {
              setOffset(offset - 10);
            }}
            className={classes.Btn}
            disabled={offset == 0}
            variant="contained"
            size="medium"
          >
            prev
          </Button>
          <Button
            onClick={() => {
              setOffset(offset + 10);
            }}
            className={classes.Btn}
            disabled={data?.getCollegeIpAddresses?.length <= 9}
            variant="contained"
            size="medium"
          >
            next
          </Button>
        </Box>
      </Paper>
    </>
  );
};
